import { render, staticRenderFns } from "./base-button.vue?vue&type=template&id=31fb6554&scoped=true"
import script from "./base-button.vue?vue&type=script&lang=js"
export * from "./base-button.vue?vue&type=script&lang=js"
import style0 from "./base-button.vue?vue&type=style&index=0&id=31fb6554&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fb6554",
  null
  
)

export default component.exports